var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 460 c0 -16 5 -30 10 -30 6 0 10 14 10 30 0 17 -4 30 -10 30 -5 0 -10 -13 -10 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 422 c0 -14 39 -46 47 -39 3 4 -2 16 -12 27 -19 21 -35 26 -35 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 410 c-10 -11 -15 -23 -12 -27 8 -7 47 25 47 39 0 14 -16 9 -35 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 390 c-88 -54 -94 -149 -16 -243 16 -19 24 -41 24 -68 0 -34 4 -41 28 -50 16 -6 39 -7 57 -2 27 8 31 14 35 55 4 28 15 57 27 70 11 13 28 37 37 55 61 121 -77 253 -192 183z m149 -36 c30 -29 45 -78 35 -117 -3 -13 -23 -45 -43 -70 -32 -40 -43 -47 -73 -47 -30 0 -41 7 -73 47 -43 53 -52 79 -43 126 6 32 45 78 76 90 32 13 92 -1 121 -29z m-41 -264 c0 -5 -13 -10 -30 -10 -40 0 -38 -18 3 -23 29 -3 29 -4 -8 -5 -36 -2 -40 0 -41 23 -2 23 2 25 37 25 21 0 39 -4 39 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 270 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10 -16 0 -30 -4 -30 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 270 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10 -16 0 -30 -4 -30 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 140 c-10 -11 -15 -23 -12 -27 8 -7 47 25 47 39 0 14 -16 9 -35 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 152 c0 -14 39 -46 47 -39 3 4 -2 16 -12 27 -19 21 -35 26 -35 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.279bbd7b6a3ee5f64b218c5b347bd5be.svg";
export { ForwardRef as ReactComponent };